import { Extension } from "@tiptap/core";

const ParagraphSpacing = Extension.create({
  name: "paragraphSpacing",

  addOptions() {
    return {
      types: ["paragraph", "heading"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          spacingBefore: {
            default: null,
            parseHTML: (element) => {
              const val = element.style.marginTop;
              return val ? parseFloat(val) : null;
            },
            renderHTML: (attributes) => {
              if (attributes.spacingBefore == null) return {};
              return { style: `margin-top: ${attributes.spacingBefore}pt` };
            },
          },
          spacingAfter: {
            default: null,
            parseHTML: (element) => {
              const val = element.style.marginBottom;
              return val ? parseFloat(val) : null;
            },
            renderHTML: (attributes) => {
              if (attributes.spacingAfter == null) return {};
              return { style: `margin-bottom: ${attributes.spacingAfter}pt` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setParagraphSpacingBefore:
        (value) =>
        ({ tr, state, dispatch }) => {
          const { from, to } = state.selection;
          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name) && dispatch) {
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                spacingBefore: value,
              });
            }
          });
          return true;
        },
      setParagraphSpacingAfter:
        (value) =>
        ({ tr, state, dispatch }) => {
          const { from, to } = state.selection;
          state.doc.nodesBetween(from, to, (node, pos) => {
            if (this.options.types.includes(node.type.name) && dispatch) {
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                spacingAfter: value,
              });
            }
          });
          return true;
        },
    };
  },
});

export default ParagraphSpacing;
